<template>
  <!-- the line under a send-method setting about «واتساب ميتا (الرسمي)»: locked (why the option is closed),
       chosen but not ready (what happens to the messages), chosen and ready (where it is set up) -->
  <div v-if="s.loaded && line" :class="'mc-hint ' + line.cls">
    <feather-icon :icon="line.icon" size="14" />
    <span>{{ line.text }}</span>
    <a v-if="locked" href="javascript:;" @click="lock">فعّله من صفحة واتساب ميتا</a>
    <router-link v-else to="/_whatsapp/meta#routing">الإعدادات والتوجيه</router-link>
  </div>
</template>

<script>
import { metaState, metaStateNow, openMetaLock } from '@/libs/meta-channel'

export default {
  name: 'MetaMethodHint',
  props: {
    value: { type: String, default: '' },
    // a tile shows its own lock: say nothing until «meta» is chosen
    quiet: { type: Boolean, default: false },
  },
  data() {
    return { s: metaStateNow() }
  },
  computed: {
    locked() {
      return !this.s.ready
    },
    line() {
      if (this.value == 'meta') {
        if (this.locked) {
          return { cls: 'mc-hint-bad', icon: 'AlertTriangleIcon',
            text: 'اخترت واتساب ميتا لكنه غير جاهز الآن، فتتبع الرسائل «بديل طريقة واتساب ميتا» في صفحة واتساب ميتا (الافتراضي: لا تُرسل).' };
        }
        return { cls: 'mc-hint-ok', icon: 'CheckCircleIcon',
          text: 'تُرسل من رقم مدرستك الرسمي بالقالب المرتبط بنوع الرسالة، أو بقالب الرسائل العامة.' };
      }
      if (this.locked && !this.quiet) {
        return { cls: 'mc-hint-muted', icon: 'LockIcon', text: 'خيار «واتساب ميتا (الرسمي)» مقفل حتى تفعيل الخدمة وربط رقمك.' };
      }
      return null;
    },
  },
  created() {
    metaState()
  },
  methods: {
    lock() {
      var g = this
      metaState(true).then(function (s) {
        if (!s.ready) openMetaLock(g)
      })
    },
  },
}
</script>
